import React from "react";
import { IconPhone, IconMail, IconInsta } from "./UI";

export default function Contact() {
  return (
    <section id="contact" className="section contact-dark">
      <div className="container">

        <div className="contact-layout">

          {/* Left — headline */}
          <div className="contact-left">
            <span className="eyebrow" style={{ color: "var(--gold)" }}>Get In Touch</span>
            <h2 className="contact-heading">
              Let's talk about your business.
            </h2>
            <p className="contact-sub">
              Tell us where you are and where you want to go. We'll figure out how to get there together.
            </p>

            <div className="contact-channels">
              <a className="contact-channel" href="https://wa.me/917975034116" target="_blank" rel="noopener noreferrer">
                <span className="contact-channel-icon"><IconPhone /></span>
                <div className="contact-channel-info">
                  <span className="contact-channel-label">WhatsApp</span>
                  <span className="contact-channel-value">+91 79750 34116</span>
                </div>
                <span className="contact-channel-arrow">↗</span>
              </a>

              <a className="contact-channel" href="mailto:ovarddigital@gmail.com">
                <span className="contact-channel-icon"><IconMail /></span>
                <div className="contact-channel-info">
                  <span className="contact-channel-label">Email</span>
                  <span className="contact-channel-value">ovarddigital@gmail.com</span>
                </div>
                <span className="contact-channel-arrow">↗</span>
              </a>

              <a className="contact-channel" href="https://www.instagram.com/ovardigital/" target="_blank" rel="noopener noreferrer">
                <span className="contact-channel-icon"><IconInsta /></span>
                <div className="contact-channel-info">
                  <span className="contact-channel-label">Instagram</span>
                  <span className="contact-channel-value">@ovardigital</span>
                </div>
                <span className="contact-channel-arrow">↗</span>
              </a>
            </div>
          </div>

          {/* Right — visual card */}
          <div className="contact-right">
            <div className="contact-card">
              <div className="contact-card-top">
                <span className="contact-card-dot" />
                <span className="contact-card-status">Available for new projects</span>
              </div>

              <div className="contact-card-body">
                <p className="contact-card-question">What do you need?</p>
                <div className="contact-card-tags">
                  {["Brand Identity", "Website", "E-commerce", "Social Content", "Meta Ads", "Google Ads", "SEO", "Full Package"].map((t) => (
                    <a key={t} href="https://wa.me/917975034116" target="_blank" rel="noopener noreferrer" className="contact-card-tag">
                      {t}
                    </a>
                  ))}
                </div>
              </div>

              <div className="contact-card-footer">
                <p className="contact-card-note">
                  Tap any service above to reach us directly on WhatsApp — or just say hello.
                </p>
                <a href="https://wa.me/917975034116" target="_blank" rel="noopener noreferrer" className="contact-card-cta">
                  Say hello →
                </a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
